//@flow
export const tradeLoyaltyStatuses = {
    BLACKLISTED: 'BLACKLISTED',
    ELIGIBLE: 'ELIGIBLE',
    ENROLLED: 'ENROLLED',
    NOT_ELIGIBLE: 'NOT_ELIGIBLE',
};

export const firmStatuses = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};

export const tradeStatuses = {
    APPLIED_IN_REVIEW: 'APPLIED_IN_REVIEW',
    APPLIED_NOT_ENOUGH_INFORMATION: 'APPLIED_NOT_ENOUGH_INFORMATION',
    APPLIED_REJECTED: 'APPLIED_REJECTED',
    NA: 'NA',
    SUSPECTED: 'SUSPECTED',
    VERIFIED_PRE_APPROVED: 'VERIFIED_PRE_APPROVED',
    VERIFIED_VETTED: 'VERIFIED_VETTED',
};

export const ACTIVE: 'ACTIVE' = 'ACTIVE';
export const PENDING: 'PENDING' = 'PENDING';
export const NEW: 'NEW' = 'NEW';
export const DELETED: 'DELETED' = 'DELETED';

export const profileStatuses = { ACTIVE, PENDING, NEW, DELETED };

export type ProfileStatus = typeof ACTIVE | typeof PENDING | typeof NEW | typeof DELETED;

export const DIRECTORY_PATH = '/design-firms/';
